import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/**
 * Big QR + short code + join URL display for the animator lobby.
 * The QR is generated client-side using the `qrcode` package already
 * installed for other features.
 */
export default function QrPanel({ code, joinUrl }) {
  const [dataUrl, setDataUrl] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let alive = true;
    if (!joinUrl) return undefined;
    QRCode.toDataURL(joinUrl, { errorCorrectionLevel: 'M', margin: 2, width: 360 })
      .then((url) => { if (alive) setDataUrl(url); })
      .catch(() => {});
    return () => { alive = false; };
  }, [joinUrl]);

  const onCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(joinUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // clipboard may be blocked; silently ignore
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem',
        padding: '1.5rem',
        background: 'var(--color-surface, white)',
        color: 'var(--color-text, inherit)',
        border: '1px solid var(--color-border, transparent)',
        borderRadius: 8,
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
      }}
    >
      <div style={{ fontSize: '0.9rem', color: 'var(--color-text-muted, #7f8c8d)', textTransform: 'uppercase', letterSpacing: '0.1em' }}>
        Code de session
      </div>
      <div
        style={{
          fontSize: '3.2rem',
          letterSpacing: '0.25em',
          fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace',
          color: 'var(--color-text, #2c3e50)',
          fontWeight: 700,
          paddingLeft: '0.25em' // counter-balance trailing letter-spacing for visual centering
        }}
      >
        {code}
      </div>

      {/* QR stays black-on-white for reliable scanning regardless of theme.
          A small white pad keeps adequate contrast on a dark page. */}
      {dataUrl ? (
        <img
          src={dataUrl}
          alt={`QR code pour rejoindre la session ${code}`}
          style={{ width: 280, height: 280, background: '#fff', padding: 4, borderRadius: 4 }}
        />
      ) : (
        <div style={{ width: 280, height: 280, background: 'var(--color-surface-2, #ecf0f1)' }} />
      )}

      <div style={{ textAlign: 'center', fontSize: '0.85rem', color: 'var(--color-text-muted, #7f8c8d)', wordBreak: 'break-all' }}>
        {joinUrl}
      </div>
      <button className="btn btn-secondary" onClick={onCopyUrl} type="button">
        {copied ? '✓ Copié' : 'Copier le lien'}
      </button>
    </div>
  );
}
